import styled from 'styled-components';

export const TextWrapper = styled.div`
  padding: 1rem 0.5rem;
  font-size: 0.9rem;
  white-space: pre-line;
`;
